import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TopRightArrowIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.topRightArrowIcon}`}
        data-testid={testId}
        fill='none'
        height='24'
        viewBox='0 0 24 24'
        width='24'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M7 17L17 7M17 7H9M17 7V15'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
        />
    </svg>
);

export default TopRightArrowIcon;
